export default "__VITE_ASSET__Dn2hQSwS__"